import script from "./table-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./table-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./table-setting-ly.vue?vue&type=style&index=0&id=4a518703&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a518703"]])

export default __exports__